// extracted by mini-css-extract-plugin
export default {"enrichment_header":"enrichment-header_enrichment_header__-xR8u"};